// ----------------------------------------------------------------------- externos
import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";

// ----------------------------------------------------------------------- internos
import { guiasDelSector } from "../services/guiasDelSector";
import { abrirSesionEnFlotaBot } from "../services/ssoFlotaBot";
import "./css/Ayuda.css";
import "./css/ComoSeUsa.css";

/* ¿Cómo se usa? Todas las guías, y a cada uno las suyas.
 *
 * Igna, 06/10/2026: «un sector que sea "¿Cómo se usa?" y ahí vamos a meter
 * TODOS los HowTo que hicimos (cada persona solamente puede ver los que son
 * relacionados a los permisos que tenga). Y de ahora en más cada vez que se
 * cree un HowTo, va para ese sector».
 *
 * NO HAY NINGUNA GUÍA ESCRITA ACÁ. Viven en FlotaBot, que es quien las sirve
 * (`/como/<slug>`) y quien sabe cuáles le tocan a cada uno. Una guía nueva
 * aparece en esta pantalla sin tocar el hub.
 *
 * SE ABREN EN OTRA PESTAÑA: una guía se lee al lado de la pantalla que
 * explica, no en lugar de ella.
 *
 * SIN TEXTOS DE RELLENO. La pantalla es la lista; lo que no le toca a alguien
 * no se nombra ni se cuenta.
 */

// El orden y el rótulo de cada tanda. Lo que venga con una clase que no está
// acá cae al final, sin rótulo, en vez de perderse.
const TANDAS = [
  ["pantalla", "En el hub"],
  ["bot", "Por WhatsApp"],
];

const ComoSeUsa = () => {
  const { verComoMail = null } = useOutletContext() || {};
  // `undefined`: todavía no contestó. `null`: no se pudo preguntar.
  const [guias, setGuias] = useState(undefined);

  /* ALGUNAS GUÍAS PIDEN LA SESIÓN DE FLOTABOT (las de RRHH y Dirección), y
   * esa sesión se abre al entrar al hub — no al recargar la página. Quien
   * llegaba acá después de un F5 tocaba la guía y le aparecía un login, estando
   * logueado. Se abre al montar, que es el mismo canje que hacen los paneles:
   * para cuando la persona elige una guía, la cookie ya está. Si falla no pasa
   * nada: las demás guías no la necesitan y ésas dos muestran su login. */
  useEffect(() => {
    Promise.resolve()
      .then(() => abrirSesionEnFlotaBot())
      .catch(() => {});
  }, []);

  useEffect(() => {
    let vigente = true;
    setGuias(undefined);
    guiasDelSector(verComoMail)
      .then((g) => vigente && setGuias(g))
      .catch(() => vigente && setGuias(null));
    return () => {
      vigente = false;
    };
  }, [verComoMail]);

  if (guias === undefined) return <div className="ayuda" aria-busy="true" />;
  if (guias === null)
    return (
      <div className="ayuda">
        <p className="tenue">No se pudo consultar.</p>
      </div>
    );

  const conocidas = TANDAS.map(([clase]) => clase);
  const tandas = [
    ...TANDAS.map(([clase, rotulo]) => [
      rotulo,
      guias.filter((g) => g.clase === clase),
    ]),
    ["", guias.filter((g) => !conocidas.includes(g.clase))],
  ].filter(([, lista]) => lista.length > 0);

  return (
    <div className="ayuda">
      {tandas.map(([rotulo, lista]) => (
        <section key={rotulo} className="ayuda-bloque">
          {rotulo && <h2>{rotulo}</h2>}
          <ul className="como-guias">
            {lista.map((g) => (
              <li key={g.url}>
                <a href={g.url} target="_blank" rel="noreferrer">
                  <b>{g.titulo}</b>
                  {g.bajada && <span>{g.bajada}</span>}
                </a>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
};

export default ComoSeUsa;
